import {FC} from 'react';
import {Box} from '@mui/material';
import {ContractsTable} from '../../modules/contracts';

const ContractsPage: FC = () => {
  return (
    <Box>
      <ContractsTable />
    </Box>
  );
};

export default ContractsPage;
